import {Box, Button, Typography} from "@mui/material";
import {useQueryClient} from "@tanstack/react-query";
import {useNavigate} from "@tanstack/react-router";

interface ErrorPageProps {
  statusCode: number;
  title: string;
  message: string;
}

const ErrorPage: React.FC<ErrorPageProps> = ({ statusCode, title, message }) => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const handleHome = () => {
    // user/me 쿼리 캐시 삭제
    queryClient.removeQueries({ queryKey: ["current-user"] });
    navigate({ to: "/" });
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
        p: 0,
        textAlign: "center",
      }}
    >
      <Typography variant='h1' sx={{ fontSize: "4rem", fontWeight: "bold", color: "primary.main" }}>
        {statusCode}
      </Typography>
      <Typography variant='h5' sx={{ mt: 2, mb: 1 }}>
        {title}
      </Typography>
      <Typography variant='body1' sx={{ mb: 3 }}>
        {message}
      </Typography>
      <Button variant='contained' onClick={handleHome}>
        홈으로 이동
      </Button>
    </Box>
  );
};

export default ErrorPage;
